<script lang="ts">
    import ResponsiveTableContainer from 'shared/ui-widgets/table/ResponsiveTableContainer.svelte';

    export let responsive = false;
    export let bordered = false;
    export let hoverRows = false;
    export let stripedRows = false;
    export let condensed = false;
    export let superCondensed = false;
    export let horizontallyDivided = false;
    export let colorAccented = false;
    export let columnHeadersCentered = false;
    export let stickyHeader = false;
    export let verticallyCentered = false;
    export let horizontallyCentered = false;
    export let additionalClasses = '';
    export let additionalContainerClasses = '';
</script>

<ResponsiveTableContainer {responsive} {additionalContainerClasses}>
    <table class="kp-generic-table table {additionalClasses}"
           class:table-hover={hoverRows}
           class:table-striped={stripedRows}
           class:table-horizontally-divided={horizontallyDivided}
           class:table-condensed={condensed}
           class:table-bordered={bordered}
           class:table-super-condensed={superCondensed}
           class:table-color-accented={colorAccented}
           class:table-centered-column-headers={columnHeadersCentered}
           class:table-sticky-header={stickyHeader}
           class:table-vertically-centered-data={verticallyCentered}
           class:table-horizontally-centered-data={horizontallyCentered}>

        {#if $$slots.header}
            <thead>
                <slot name="header"/>
            </thead>
        {/if}

        <tbody>
            <slot name="body"/>
        </tbody>

        {#if $$slots.footer}
            <tfoot>
                <slot name="footer"/>
            </tfoot>
        {/if}
    </table>
</ResponsiveTableContainer>

<style lang="less">
    @import (reference) "styles/portaro.media-queries.less";
    @import (reference) "styles/portaro.variables.less";
    @import (reference) "styles/portaro.themes.less";

    .kp-generic-table {
        margin-bottom: 0;

        &.table-bordered {
            border: 1px solid @themed-border-default;
            border-radius: @border-radius-default;
        }

        &.table-responsive {
            overflow-y: hidden;

            @media screen and (max-width: @screen-xs-max) {
                margin-bottom: 0;
            }
        }

        &.table-super-condensed {
            :global {
                > thead,
                > tbody,
                > tfoot {
                    > tr {
                        > th {
                            padding: 3px 5px;
                            font-size: 12px;
                        }

                        > td {
                            padding: 0;
                            font-size: 12px;
                        }
                    }
                }
            }
        }

        &.table-sticky-header {
            border-collapse: separate;

            thead {
                background-color: @themed-body-bg;
                position: sticky;
                top: 0;
                z-index: 90;
            }
        }
    }

    :global {
        .kp-generic-table {
            &.table-vertically-centered-data {
                tr > th,
                tr > td {
                    vertical-align: middle !important;
                }
            }

            &.table-horizontally-centered-data {
                tr > th,
                tr > td {
                    text-align: center;
                }
            }

            &.table-hover > tbody > tr:hover {
                transition: background-color 0.2s ease-in-out;
            }

            &.table-color-accented > thead > tr > th {
                color: var(--table-header-accent-color);
                border-bottom: 2px solid var(--table-header-accent-color);
            }

            &.table-centered-column-headers > thead > tr > th {
                text-align: center;
                vertical-align: middle;
                line-height: 1.25;
            }
        }
    }
</style>